//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import channelTypesMixin from '@motionelements/core/src/components/mixins/channelTypes.mixin.js';

export default {
  name: 'FreeButton',
  mixins: [channelTypesMixin],
  components: {
    ProductIcon: () => import('@motionelements/core/src/components/product/ProductIcon.vue'),
  },
  props: {
    mediaType: {
      type: String,
      required: true,
    },
    linkUrl: {
      type: String,
    },
  },
  computed: {
    freePagePath() {
      if (this.mediaType === 'gif') {
        return '/free/gifs';
      }
      return _.get(this.getChannelTypeById(this.mediaType), 'freeLink');
    },
    label() {
      return _.upperFirst(this.$term('mediaType', this.mediaType).wbr().plural().html());
    },
  },
};
